module.exports = __webpack_public_path__ + "img/zsMapbg2.f2bd345c.png";